import React from 'react';
import './Plumbing.css';
import Menu from '../../Menu/Menu';
import b8 from '../../../img/History-of-Plumbing.png';



const Plumbing = () => {
    return (
        <div className='mb-5'>
            
            <div className='about9'>
                <div className='bg'>
                    <Menu></Menu>
                    <h1 className='text-white display-5 fw-bold doris pt-lg-5 pb-5 mx-auto top'>Plumbing</h1>
                </div>
            </div>

            <div id="gis">
                <h2 className='heading pt-5 px-3'>Plumbing</h2>
                <hr className='w-50 mx-auto'></hr>
                <h5 className='px-5 mx-lg-3'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 pt-3 mb-3'>
                        Plumbing is any system that conveys fluids for a wide range of applications.
                        Plumbing uses pipes, valves, plumbing fixtures, tanks, and other apparatuses
                        to convey fluids. We are using high technology for developing plumbing
                        systems.
                            {/* <img src={b8} alt="" width="100%" className='me-2'/> */}
                        </div>
                        
                        <div className='col-lg-6 col-md-6 col-sm-12 px-lg-5'>
                            <div className='mt-3'>
                                    <img src={b8} alt="" width="100%" className='me-2 mb-3'/>
                                </div>
                        </div>
                    </div>
                </h5>
            </div>            
        </div>
    );
};

export default Plumbing;